module.exports = __webpack_public_path__ + "img/btnStatus7.182f7ae7.png";